import { AxiosResponseHeaders } from 'axios';
import { GenericObject, Nullable } from '@dxb-web-ui-framework/common/types';
import { ConsolidatedTransaction } from '../../entities/ConsolidatedTransaction';
import {
  ConsolidatedTransactionResponseDTO,
  ConsolidatedTransactions,
} from '../../entities/ConsolidatedTransaction/ConsolidatedTransactionResponseDTO';

// TODO: implement when new api exists
const ConsolidatedTransactionsResponseDTOtoConsolidatedTransactionsAdapter = (
  response: ConsolidatedTransactionResponseDTO,
  headers?: AxiosResponseHeaders,
  meta?: Nullable<GenericObject>,
): ConsolidatedTransactions => {
  if (!response.body) {
    throw Error();
  }

  return {
    totalItems: response.body.paginationTotal,
    transactions: response.body.globalOrders.map(
      transaction =>
        new ConsolidatedTransaction(
          transaction.customerId,
          transaction.customerDigit,
          transaction.customerSurname,
          transaction.system,
          transaction.accountNumber,
          transaction.accountCode,
          transaction.currencyId,
          transaction.currencyShortDescription,
          transaction.routeGenericDetailDescription,
          transaction.routeGenericDetailShortDescription,
          transaction.routeGenericDetailParameterType,
          transaction.routeGenericDetailSerialNum,
          transaction.orderId,
          transaction.orderCode,
          transaction.orderTrxDate,
          transaction.orderDirection,
          transaction.orderAmount,
          transaction.orderMessageType,
          transaction.beneficiaryName,
          transaction.beneficiaryAccount,
          transaction.beneficiaryIsoCountry,
          transaction.beneficiaryBic,
          transaction.beneficiarySortCode,
          transaction.orderComments,
          transaction.externalIdRef,
          transaction.processType,
          transaction.correspondingAccount,
          transaction.correspondingCustomerId,
          transaction.trxUser,
          transaction.trxUnit,
          transaction.timestamp,
          transaction.orderLogicalKey,
          transaction.financialDate,
          transaction.routingResultDescription,
          transaction.orderValueDate,
          transaction.processingStatus,
          transaction.systemDate,
          transaction.transferDate,
          transaction.beneficiaryBank,
          transaction.status,
        ),
    ),
  };
};

export { ConsolidatedTransactionsResponseDTOtoConsolidatedTransactionsAdapter };
